import { render, staticRenderFns } from "./ReincorporateEmployeeDialog.vue?vue&type=template&id=60872b80"
import script from "./ReincorporateEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./ReincorporateEmployeeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports